__turbopack_context__.v({
  "noWorkflowsText": "WorkflowsTable-module__zLXwNq__noWorkflowsText",
  "table": "WorkflowsTable-module__zLXwNq__table",
  "tableActions": "WorkflowsTable-module__zLXwNq__tableActions",
  "tableContainer": "WorkflowsTable-module__zLXwNq__tableContainer",
  "td": "WorkflowsTable-module__zLXwNq__td",
  "th": "WorkflowsTable-module__zLXwNq__th",
});
